import { render } from "./pc_property_add.vue?vue&type=template&id=0b19e988&scoped=true"
import script from "./pc_property_add.vue?vue&type=script&lang=js"
export * from "./pc_property_add.vue?vue&type=script&lang=js"

import "./pc_property_add.vue?vue&type=style&index=0&id=0b19e988&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b19e988"]])

export default __exports__